import { IUnSdg } from 'src/types'
import { HighlightedText } from 'src/components'
import { List, ListImage, TitleItem, ListImageWrapper } from './product-image.styled'
import { FAIRTRADE_FONT_STACK } from 'src/templates/fairtrade/constants'
import { Avatar } from '@mui/material'
import { imgSt } from '../bottom-card-title/bottom-card-title.styled'

interface IProps {
  title?: string
  unSdg?: IUnSdg[]
  withIndicator?: boolean
  fontFamily?: string
  titleFontSize?: string | number
  titleFontWeight?: number | string
  titleBackgroundColor?: string
  titleColor?: string
  accountImage?: string
}

export const ProductImageOverlay = ({
  title,
  accountImage,
  unSdg,
  withIndicator,
  fontFamily = FAIRTRADE_FONT_STACK,
  titleFontSize = '24px',
  titleFontWeight = 600,
  titleBackgroundColor = '#FFFFFF',
  titleColor = '#000000',
}: IProps) => {
  const hasTitle = !!title
  const hasUnSdg = unSdg && Array.isArray(unSdg) && unSdg.length > 0
  const hasContent = hasTitle || hasUnSdg

  if (!hasContent) {
    return null
  }

  return (
    <List
      id="product-image-overlay__components-product-image__list__l12"
      withIndicator={withIndicator}
    >
      {accountImage && (
        <TitleItem>
          <Avatar className={imgSt} alt={title} src={accountImage} />
        </TitleItem>
      )}

      {hasTitle && (
        <TitleItem
          sx={{ mb: '8px', textAlign: 'start' }}
          id="product-image-overlay__components-product-image__title__l16"
        >
          <HighlightedText
            text={title}
            fontSize={titleFontSize}
            fontWeight={titleFontWeight}
            fontFamily={fontFamily}
            backgroundColor={titleBackgroundColor}
            color={titleColor}
            sx={{ textAlign: 'start' }}
          />
        </TitleItem>
      )}
      {hasUnSdg &&
        unSdg.map((item) => (
          <ListImageWrapper
            id="product-image-overlay__components-product-image__li__l24"
            key={item.id}
          >
            <ListImage
              id="product-image-overlay__components-product-image__listimage__l25"
              src={item.image_medium || item.image}
              alt={item.name}
            />
          </ListImageWrapper>
        ))}
    </List>
  )
}
